import List from "@/components/visualizations/List/List";
import useTranslation from "@/hooks/useTranslation";
import Widget from "@/pages/dashboard/components/Widget/Widget";
import {
  ProductBy,
  useTopContributingPackagingMaterials,
} from "@/pages/dashboard/hooks/useProductImpact";
import { formatAmountWithUnit } from "@/pages/dashboard/utils/formatters";
import { ImpactMetric } from "@/pages/dashboard/utils/types";
import CrossReference from "@/components/links/CrossReference/CrossReference";

function TopContributingPackagingMaterials({
  productId,
  metric,
  by,
}: {
  productId: number;
  metric: ImpactMetric;
  by: ProductBy;
}) {
  const { data, isLoading, isFetching } = useTopContributingPackagingMaterials({
    productId,
    by,
    metric: metric.key,
  });

  const translation = useTranslation();

  const listData = data
    ? data
        .filter((row) => row.material_id)
        .map((row) => {
          return {
            label: (
              <CrossReference to={`/matching/packaging/materials/${row.material_id}`}>
                {row.material_name}
              </CrossReference>
            ),
            value: row.impact?.[metric.key] || 0,
            extraProp: {
              label: "Amount",
              value: formatAmountWithUnit(row.amount, row.unit, 0),
            },
          };
        })
    : [];

  const total = listData.reduce((acc, curr) => acc + curr.value, 0);

  return (
    <Widget
      title={translation["productDrawer"]["topContributorsPackaging"]["title"]}
      tooltip={translation["productDrawer"]["topContributorsPackaging"]["description"]}
    >
      <List
        loading={isLoading || isFetching}
        data={{
          list: listData,
          total: total,
        }}
        format={metric.formatter}
      />
    </Widget>
  );
}

export default TopContributingPackagingMaterials;
